import React from "react";
import styled from "styled-components";
import { Message, TextButton } from "components/pages/WarmUpPicker/styles";

// Where the Warm-Up Groups section would be, when its list failed to load.
const Block = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WarmUpGroupsLoadError = ({ onRetry, style }) => (
  <Block style={style}>
    <Message role="alert">We couldn&apos;t load your warm-up groups.</Message>
    <TextButton type="button" onClick={() => onRetry?.()}>
      <span>Try Again</span>
    </TextButton>
  </Block>
);
